import { Grid, Typography, Button, Box } from "@mui/material"; // Use MUI's Button

import React from "react";
import NormalDatePicker from "./NormalDatePicker";
import CustomSearchField from "./CustomSearchField";
import RefreshIcon from "@mui/icons-material/Refresh";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
const AdminControl = ({
  title,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  GetFunction,
  ResetFunction,
  searchQuery,
  setSearchQuery,
  isSubmit = false,
  handleSubmit,
  selectedIds =[]
}) => {
  const handleFromDateChange = (date) => {
    setFromDate(date); // Update the from date
    // If the new from date is greater than the current to date, reset the to date
    if (toDate && date > toDate) {
      setToDate(null);
    }
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };
 const today = localStorage.getItem('serverTime') ? new Date(localStorage.getItem('serverTime')) : new Date();

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Urbane-Demibold",
            fontSize: "16px",
            fontWeight: "700",
            lineHeight: "40px",
            textAlign: "left",
            color: "#250258",
            pb: 2,
          }}
        >
          {title}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}></Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "column", lg: "row" }, // Column for small screens, row for larger screens
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={8} container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6} md={3}>
              <NormalDatePicker
                label="From date"
                name="from_date"
                selected={fromDate}
                onChange={handleFromDateChange}
                maxDate={today} // Disable dates greater than today
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <NormalDatePicker
                label="To date"
                name="to_date"
                selected={toDate}
                onChange={handleToDateChange}
                maxDate={today} // Disable dates greater than today
                minDate={fromDate} // Only allow dates greater than or equal to the from date
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Button
                variant="contained"
                sx={{
                  mx: {
                    xs: 0,
                    sm: 1,
                    fontFamily: "Urbane-Light",
                    fontSize: "12px",
                  },
                  mt: { xs: 2, sm: 0 },
                }} // Adjust margin for responsiveness
                onClick={() => GetFunction()}
              >
                Apply
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                sx={{
                  backgroundColor: "#F13131",
                  "&:hover": {
                    backgroundColor: "#d32f2f", // Darker red for hover state
                  },
                }}
                onClick={ResetFunction}
              >
                <RefreshIcon />
              </Button>
            </Grid>
          </Grid>

          <Grid item xs={12} md={4}>
  <Grid container spacing={2} alignItems="center" justifyContent="flex-end">
    <Grid item xs={8}>
      <TextField
        variant="outlined"
        placeholder="Search..."
        value={searchQuery}
        fullWidth
        onChange={(e) => setSearchQuery(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          sx: {
            height: "40px",
            "& .MuiOutlinedInput-input": {
              padding: "8px",
              fontFamily: "Urbane-Light",
              fontSize: "13px",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "grey",
            },
          },
        }}
        sx={{
          borderRadius: "50px",
          "& .MuiOutlinedInput-root": {
            borderRadius: "50px",
            height: "40px", // Ensure consistent height
            fontFamily: "Urbane-Light",
            fontWeight: 500,
          },
          "& .MuiOutlinedInput-input": {
            padding: "10px 12px",
            fontSize: "13px",
          },
        }}
      />
    </Grid>
    {isSubmit && (
      <Grid item>
        <Button
          variant="contained"
          sx={{
            height: "40px", // Match height of TextField
            fontFamily: "Urbane-Light",
            fontSize: "12px",
            padding: "0 16px", // Adjust padding for balanced appearance
          }}
          onClick={handleSubmit}
          disabled={selectedIds.length === 0}
        >
          Submit
        </Button>
      </Grid>
    )}
  </Grid>
</Grid>

        </Grid>
      </Box>
    </div>
  );
};

export default AdminControl;
